<template>
  <div>
    <label
      class="input__label"
      :for="id"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <app-google-autocomplete
      class="margin__t--6"
      :id="id"
      :type="type"
      :placeholder="translate(placeholder)"
      :v="validator"
      v-model="model"
      v-if="isGoogleMapsAllowed"
    />

    <app-open-street-map-autocomplete
      class="margin__t--6"
      :id="id"
      :type="type"
      :placeholder="translate(placeholder)"
      :v="validator"
      v-model="model"
      v-else
    />
  </div>
</template>

<script setup>
import { computed, inject, defineAsyncComponent } from 'vue'
import { useModule } from '@/composables/app/useModule'
import { useProcedureBlockValidator } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'
import { useConsent } from '@/vendors/consent'
import Address from '@/classes/addresses/Address'
import { required } from '@vuelidate/validators'
import { get as _get } from 'lodash'

const AppGoogleAutocomplete = defineAsyncComponent(() => import('&/atoms/AppGoogleAutocomplete'))
const AppOpenStreetMapAutocomplete = defineAsyncComponent(() => import('&/atoms/AppOpenStreetMapAutocomplete'))

const { block } = defineProps({ block: { type: Object, required: true } })

const procedure_execution = inject('procedure_execution')

const { translate } = useI18n()
const { isVendorAllowed } = useConsent()
const { label, placeholder, model, attributes, id, defaultValue } = useModule({ component: block, parent: procedure_execution, default_value: new Address() })
const { validator } = useProcedureBlockValidator({ validations: block.is_required ? { required } : {}, state: computed(() => model.value.country) })

const type = _get(attributes.value, 'type', '(regions)')

const isGoogleMapsAllowed = computed(() => isVendorAllowed('google_maps'))

if (!model.value && defaultValue.value) model.value = defaultValue.value
</script>
